import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import {
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardText,
} from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import Loading from '../shared/Loading';

class EirBBInfoResultContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: "",
      downSpeed: "",
      downSpeedUnit: "",
      upSpeed: "",
      upSpeedUnit: "",
      max: "",
      norm: "",
      min: "",
    };
  }

  componentDidMount() {
    /*
    let cookies = document.cookie;
    let bbinfoString = this.getCookie('bbinfo');
    var bbinfo = JSON.parse(bbinfoString);
    var down = bbinfo.down_speed.split(" ");
    var up = bbinfo.up_speed.split(" ");
    */

    var bbinfo = JSON.parse(this.props.jsonString);
    var down = bbinfo.down_speed.split(" ");
    var up = bbinfo.up_speed.split(" ");

    this.setState({
      phoneNumber: bbinfo.std_phone_number,
      downSpeed: down[0],
      downSpeedUnit: down[1],
      upSpeed: up[0],
      upSpeedUnit: up[1],
      max: bbinfo.max,
      norm: bbinfo.norm,
      min: bbinfo.min,
    });

  }

  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  render() {
    return (
      <Container className="d-flex flex-column justify-content-center align-items-center">
        <Row><h4 className="mt-3 text-dark">Broadband line information</h4></Row>
        <Row>
          <div>
            <p className="pb-0 mb-0 text-center">Results for your maximum, normally available and minimum download and upload speeds on your broadband line.</p>
          </div>
        </Row>
        <Row>
          <Card className="eir-form mb-4 mb-md-5 mb-lg-6">
            <CardBody>
              <CardSubtitle className="pb-2">Checking broadband speeds for:</CardSubtitle>
              <CardTitle className="text-base-gray">{this.state.phoneNumber}</CardTitle>
              <Row>
                <img className="mx-auto d-block pb-2" width="10%" height="10%" src="/.galleries/eir/nn/speedo.png" />
              </Row>
              <Row>
                <Col className="border-right border-bottom">
                  <Row>
                    <img className="mx-auto d-block  pb-0" width="10%" height="10%" src="/.galleries/eir/nn/downstream-icon.png" />
                  </Row>
                  <p className="color-turquoise pb-0">DOWNLOAD</p>
                  <h1 className="justify-content-center pb-0">{this.state.downSpeed}</h1>
                  <p className="color-turquoise">{this.state.downSpeedUnit}</p>
                </Col>
                <Col className="border-bottom">
                  <Row>
                    <img className="mx-auto d-block pb-0" width="10%" height="10%" src="/.galleries/eir/nn/upstream-icon.png" />
                  </Row>
                  <p className="color-turquoise pb-0">UPLOAD</p>
                  <h1 className="justify-content-center pb-0">{this.state.upSpeed}</h1>
                  <p className="color-turquoise">{this.state.upSpeedUnit}</p>
                </Col>
              </Row>
              <Row className="pt-4 justify-content-center">
                <CardText>You should expect your line to receive the following</CardText>
              </Row>
              <Row className="pt-0 pb-4 justify-content-center">
                <CardText>percentages of these speeds when you're connected via cable</CardText>
              </Row>
              <Row className="pb-4 justify-content-end">
                <CardText className="font-weight-bold">Download & Upload</CardText>
              </Row>
              <Row className="eir-nn-bg-gray pb-3">
                <Col >
                  <p className="text-left">Maximum</p>
                </Col>
                <Col>
                  <p className="font-weight-bold text-right">{this.state.max}</p>
                </Col>
              </Row>
              <Row className="eir-nn-bg-normal">
                <Col>
                  <p className="text-left">Normally available</p>
                </Col>
                <Col>
                  <p className="font-weight-bold text-right">{this.state.norm}</p>
                </Col>
              </Row>
              <Row className="eir-nn-bg-gray">
                <Col>
                  <p className="text-left">Minimum</p>
                </Col>
                <Col>
                  <p className="font-weight-bold text-right">{this.state.min}</p>
                </Col>
              </Row>
              <EirButton className="mt-4"
                type="button"
                link="/broadbandlineinfo"
                text="CHECK ANOTHER NUMBER"
                name="redirectTo"
              />

            </CardBody>

          </Card>
        </Row>
        <Row className="justify-content-center w-100">
            <Col xs="12">
              <p className="text-center">Please note that the results shown should be achievable through a direct cable connection from your PC/Laptop to your modem, with no other devices connected to your modem and subject to the performance of your PC/Laptop. Under more typical usage conditions, the broadband speeds that you experience can be affected by a number of external factors.</p>
              <p className="text-center">Click <a href="https://www.eir.ie/support/broadband/boost-your-broadband-speeds/ " target="_blank">here</a> for more information on how to boost your broadband speed.</p>
              <p className="text-center">Click <a href="https://www.eir.ie/opencms/export/sites/default/.content/pdf/terms/general/eir_standard_broadband_terms_and_conditions.pdf" target="_blank">here</a> for eir Broadband Terms and Conditions.</p>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default EirBBInfoResultContainer;